import { AxiosInstance } from 'axios';
import { ProviderProfile } from './types';
import { apiRequest } from './apiRequest';
import { ApiResponse } from './types';

export type GetProviderProfile = (providerId: string) => Promise<ApiResponse<ProviderProfile>>;

const getProviderProfile = (api: AxiosInstance): GetProviderProfile => {
  return async (providerId: string) => {
    return apiRequest<ProviderProfile>(api, {
      method: 'GET',
      url: `/api/custom-booking/provider/${providerId}`
    });
  };
}

export default getProviderProfile;